import React from 'react';
import { useNavigate } from 'react-router-dom';
import StorefrontIcon from '../../components/Icons/StorefrontIcon';
import InventoryIcon from '../../components/Icons/Inventory';
import { useLoginState } from '../../hooks/useLoginState';
import './styles.css';

const HomePage = () =>
{
  const navigate = useNavigate();
  const { enabledModules = [] } = useLoginState();

  return (
    <div className="homepage-container">
      <div className="homepage-content">
        <div className="homepage-boxes">
          {enabledModules.includes('TARGET_SALES') && (
            <div
              className="homepage-box"
              onClick={() => navigate('/projects')}
            >
              <span className="homepage-box-icon"><StorefrontIcon /></span>
              <span className="homepage-box-label">Performance</span>
            </div>
          )}
          {enabledModules.includes('INVENTORY') && (
            <div
              className="homepage-box"
              onClick={() => navigate('/inventory-management')}
            >
              <span className="homepage-box-icon"><InventoryIcon width={28} height={28} /></span>
              <span className="homepage-box-label">Inventory Management</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
